import data from '@iez/lib/data/'
import waitFor from '@iez/lib/wait-for/'
import chroma from 'chroma-js'
import firebase from 'firebase/app'
import 'firebase/auth'
import { flatten, sampleSize } from 'lodash'
import video from './video.mp4'
import avatarYako from './avatar-yako.png'

const generateImageIds = async ({ length }) => {
  return Promise.all(
    Array.from({ length }, async () => {
      const file = data.upload({
        file: {
          placeholder: chroma.random().hex()
        },
        type: `image`
      })
      await waitFor({
        dependencies: () => file.id
      })
      return file.id
    })
  )
}

/**
 * Reset all
 */
const deleteAll = async () => {
  const roots = [
    `requestsToBecomeAssociation`,
    `requestsToWithdraw`,
    `associationsThemes`,
    `viewsAds`,
    `associations`,
    `themes`,
    `payments`,
    `ads`,
    `payments`,
    `followsUsers`,
    `likesComments`,
    `comments`,
    `likesPosts`,
    `posts`,
    `users`,
    `videos`,
    `images`
  ]

  for (const root of roots) {
    await data.remove({
      root,
      where: {},
      parents: []
    }).catch(error => {
      console.error('error', error)
    })
  }
}

const addUsers = async () => {
  const imageIds = await generateImageIds({ length: 10 })

  const file = new Blob([
    await (await fetch(avatarYako)).arrayBuffer()
  ], {
    type: `image/png`
  })

  const avatarYakoImage = data.upload({
    type: `image`,
    file
  })

  await waitFor({
    dependencies: () => avatarYakoImage.id
  })

  const items = Array.from({
    length: 11
  }, (_, index) => index === 10
    ? {
      imageId: avatarYakoImage.id,
      name: `Yako`,
      phoneNumber: `+33632210026`,
      description: `Compte officiel de Yako`,
      privateName: `Yannaël`,
      privateSurname: `Bossard`,
      isAdmin: true
    } : {
      imageId: imageIds[index],
      name: `${index < 5 ? `Asso` : `Giver`} ${index}`,
      phoneNumber: `+336${`${index}`.repeat(8)}`,
      description: `Description ${index}`,
      privateName: `Private name ${index}`,
      privateSurname: `Private surname ${index}`,
      isAdmin: index === 0
    })

  const users = await data.set({
    root: `users`,
    items,
    fields: [`id`]
  })
  return users
}

const addThemes = async () => {
  const imageIds = await generateImageIds({ length: 10 })

  const themes = await data.set({
    root: `themes`,
    items: Array.from({
      length: 10
    }, (_, index) => ({
      imageId: imageIds[index],
      name: `Theme ${index}`,
      color: chroma.random().hex()
    })),
    fields: [
      `id`
    ]
  })
  return themes
}

const addAssociations = async () => {
  const associations = await data.set({
    root: `associations`,
    items: [
      ...Array.from({
        length: 5
      }, (_, index) => ({
        phoneNumber: `+336${`${index}`.repeat(8)}`
      })), {
        phoneNumber: `+33632210026`
      }
    ],
    fields: [
      `id`
    ]
  })
  return associations
}

const addPosts = async ({ users }) => {
  const postsCount = 10

  const imageIds = await generateImageIds({
    length: users.length * postsCount
  })

  const posts = await data.set({
    root: `posts`,
    items: flatten(users.map(({ id: authorId }, userIndex) => Array.from({
      length: postsCount
    }, (_, index) => ({
      content: `Content ${index}`,
      authorId,
      imageId: imageIds[userIndex * postsCount + index],
      userId: (index % 2) ? authorId : undefined
    })))),
    fields: [
      `id`
    ]
  })
  return posts
}

const addAssociationsThemes = async ({ themes, associations }) => {
  for (const { id: associationId } of associations) {
    const randomThemes = sampleSize(themes, 3)
    await data.set({
      root: `associationsThemes`,
      items: randomThemes.map(({ id: themeId }) => ({
        themeId,
        associationId
      })),
      fields: [
        `id`
      ]
    })
  }
}

const addAds = async ({ users }) => {
  const file = new File([
    await (await fetch(video)).arrayBuffer()
  ], ``, {
    type: `video/mp4`
  })

  const _video = data.upload({
    file,
    type: `video`
  })
  await waitFor({
    dependencies: () => _video.id
  })

  await data.set({
    root: `ads`,
    items: [{
      videoId: _video.id,
      authorId: users[0].id,
      name: `Annonce vidéo`
    }],
    fields: [
      `id`, {
        video: [
          `id`,
          `src`
        ]
      }
    ]
  })
}

export default async () => {
  await firebase.auth().signOut()
  await deleteAll()
  const users = await addUsers()
  await addPosts ({ users })
  const themes = await addThemes()
  const associations = await addAssociations()
  await addAssociationsThemes({
    themes,
    associations
  })
  await addAds({ users })
}
